import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'

// 公共数据
import common from './modules/common'
// 用户数据
import user from './modules/user'
// TODO
// 小七当家
import service from '../service/service'
// // 装修管理
// import zxgl from '../service/zxgl/zxgl'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // 公共State
    common,
    user,
    // 统一修改—>Actions
    service
    // zxgl,
  },
  // model主入口
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js